import { authApi } from '@ports/internal-services/auth/authApi';
import { notificationApi } from '@ports/internal-services/notification/notificationApi';

export const clearCachedAPIs = (dispatch: any) => {
  dispatch(authApi.util.resetApiState());
  dispatch(notificationApi.util.resetApiState());
};
